import { useState, useEffect } from "react";
import Cropper from "react-easy-crop";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const ASPECTS = [
  { label: "Landscape", value: 4 / 3 },
  { label: "Portrait", value: 3 / 4 },
  { label: "Square", value: 1 },
];

export function CropDialog({ photo, onClose, onApply }) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [aspect, setAspect] = useState(4 / 3);
  const [area, setArea] = useState(null);

  useEffect(() => { setCrop({ x: 0, y: 0 }); setZoom(1); }, [photo]);

  return (
    <Dialog open={!!photo} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="crop-dialog" className="ph-no-capture border-[#4A4540]/15 bg-[#FDFBF7] sm:max-w-xl">
        <DialogTitle className="font-serif text-2xl text-[#2C2A28]">Crop your photo</DialogTitle>
        <DialogDescription className="text-[#8A7F76]">Cropping happens on this device only.</DialogDescription>
        {photo && (
          <>
            <div className="relative h-72 w-full overflow-hidden rounded-xl bg-[#2C2A28]">
              <Cropper
                image={photo.src}
                crop={crop}
                zoom={zoom}
                rotation={photo.rotation}
                aspect={aspect}
                onCropChange={setCrop}
                onZoomChange={setZoom}
                onCropComplete={(_, px) => setArea(px)}
              />
            </div>
            <div className="flex flex-wrap items-center gap-2">
              {ASPECTS.map((a) => (
                <button
                  key={a.label}
                  type="button"
                  data-testid={`crop-aspect-${a.label.toLowerCase()}`}
                  onClick={() => setAspect(a.value)}
                  className={`rounded-full border px-3 py-1 text-xs font-medium ${aspect === a.value ? "border-[#E07A5A] bg-[#F6E2D8] text-[#A84A32]" : "border-[#4A4540]/20 text-[#4A4540]"}`}
                >
                  {a.label}
                </button>
              ))}
              <input
                type="range"
                min={1}
                max={3}
                step={0.05}
                value={zoom}
                data-testid="crop-zoom"
                onChange={(e) => setZoom(Number(e.target.value))}
                className="ml-auto w-32 accent-[#E07A5A]"
                aria-label="Zoom"
              />
            </div>
            <div className="flex justify-end gap-2">
              <Button data-testid="crop-cancel-btn" variant="outline" onClick={onClose} className="rounded-full">Cancel</Button>
              <Button data-testid="crop-apply-btn" disabled={!area} onClick={() => onApply(area)} className="rounded-full bg-[#E07A5A] text-white hover:bg-[#d66b4b]">Apply crop</Button>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
